import { render, staticRenderFns } from "./InvitationHandler.vue?vue&type=template&id=451aa1ce&scoped=true"
import script from "./InvitationHandler.vue?vue&type=script&lang=js"
export * from "./InvitationHandler.vue?vue&type=script&lang=js"
import style0 from "./InvitationHandler.vue?vue&type=style&index=0&id=451aa1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451aa1ce",
  null
  
)

export default component.exports